import React from "react";
import { Button } from "../Button";
import CustomerDetails from "../CustomerDetails";
import { CustomerDataStateObject } from "../../hooks/useCustomerDataState";
import "./CustomerSummary.css";

export interface CustomerSummaryProps {
  customer?: CustomerDataStateObject;
  summaryFields?: string[];
  loading?: boolean;
  onComplete: React.MouseEventHandler<HTMLButtonElement>;
  onReturn: React.MouseEventHandler<HTMLButtonElement>;
  t: Function;
}

export default function CustomerSummary({
  customer,
  summaryFields,
  loading,
  onComplete,
  onReturn,
  t
}: CustomerSummaryProps) {
  return (
    <div className="customer-thanks">
      <h3 className="customer-summary-title">
        {t("customer.summary.page.title")}
      </h3>
      <div className="customer-summary-body">
        {customer && summaryFields && (
          <CustomerDetails customer={customer} columns={summaryFields} t={t} />
        )}
      </div>
      <div className="button-group button-group-horizontal">
        <Button
          label={t("customer.summary.buttons.return.label")}
          theme="neutral"
          shape="solid"
          className="button-role-back"
          onClick={onReturn}
          disabled={loading}
        />
        <Button
          label={t("customer.summary.buttons.continue.label")}
          theme="primary"
          shape="solid"
          className="button-role-submit"
          onClick={onComplete}
          disabled={loading}
        />
      </div>
    </div>
  );
}
